<template>
  <div class="content-body">

    <div class="content" id="content-retract" v-if="!sonPageShow">

      <div class="buttons-box">
        <div class="buttons-box-header" @click="retract">
          <span>财务概览</span>
          <img src="../../static/img/retract.png" style="transform: rotate(180deg);">
        </div>
        <div class="buttons-box-retract">
          <div class="buttons-box-retract-box">
            <div class="buttons-item">
              <div>
                <img src="../../static/img/market/zzx.svg">
                <span @click="details(11)">增长型</span>
                <p>企业综合利润上涨类型</p>
              </div>
            </div>
            <div class="buttons-item">
              <div>
                <img src="../../static/img/market/zzkzx.svg">
                <span @click="details(12)">自主扩张型</span>
                <p>企业利润为正，准备花钱投资固定资产在建工程等以推动后续发展的类型</p>
              </div>
            </div>
            <div class="buttons-item">
              <div>
                <img src="../../static/img/market/hxlrws.svg">
                <span @click="details(13)">核心利润萎缩</span>
                <p>查看主营业务利润下滑企业</p>
              </div>
            </div>
            <div class="buttons-item">
              <div>
                <img src="../../static/img/market/sy.svg">
                <span @click="details(14)">商誉</span>
                <p>分析企业收购子公司溢价对未来利润风险的影响</p>
              </div>
            </div>
            <div class="buttons-item">
              <div>
                <img src="../../static/img/market/lrjhx.svg">
                <span @click="details(15)">收入/利润均衡性</span>
                <p>收入和利润差异对比</p>
              </div>
            </div>
            <div class="buttons-item">
              <div>
                <img src="../../static/img/market/stx.svg">
                <span @click="details(16)">衰退型</span>
                <p>企业综合利润下降类型</p>
              </div>
            </div>
            <div class="buttons-item">
              <div>
                <img src="../../static/img/market/jrtzx.svg">
                <span @click="details(17)">金融投资型</span>
                <p>企业金融投资收益增长类型</p>
              </div>
            </div>
            <div class="buttons-item">
              <div>
                <img src="../../static/img/market/tzslx.svg">
                <span @click="details(18)">投资失利型</span>
                <p>企业投资收益为负且对净利润有严重影响的类型</p>
              </div>
            </div>
            <div class="buttons-item">
              <div>
                <img src="../../static/img/market/xyjz.svg">
                <span @click="details(19)">信用减值</span>
                <p>企业信用减值为负严重影响利润类型</p>
              </div>
            </div>
            <div class="buttons-item">
              <div>
                <img src="../../static/img/market/xjljhx.svg">
                <span @click="details(110)">利润/现金流均衡性</span>
                <p>利润和现金流差异对比</p>
              </div>
            </div>
            <div class="buttons-item">
              <div>
                <img src="../../static/img/market/ysjgbh.svg">
                <span @click="details(111)">营收结构变化</span>
                <p>揭示企业主营结构变更情况</p>
              </div>
            </div>
            <div class="buttons-item">
              <div>
                <img src="../../static/img/market/bgfzx.svg">
                <span @click="details(112)">并购发展型</span>
                <p>企业对外股权投资收益增长类型</p>
              </div>
            </div>
            <div class="buttons-item">
              <div>
                <img src="../../static/img/market/zrzgs.svg">
                <span @click="details(113)">转让子公司</span>
                <p>企业转让子公司收益为负且对净利润有严重影响的类型</p>
              </div>
            </div>
            <div class="buttons-item">
              <div>
                <img src="../../static/img/market/zcjz.svg">
                <span @click="details(114)">资产减值</span>
                <p>企业资产减值为负严重影响利润类型</p>
              </div>
            </div>
            <div class="buttons-item">
              <div></div>
            </div>
            <div class="buttons-item">
              <div>
                <img src="../../static/img/market/lrjgbh.svg">
                <span @click="details(115)">利润结构变化</span>
                <p>呈现企业利润结构变化</p>
              </div>
            </div>
            <div class="buttons-item">
              <div>
                <img src="../../static/img/market/gggx.svg">
                <span @click="details(116)">高杠杆型</span>
                <p>快速定位高负债企业</p>
              </div>
            </div>
            <div class="buttons-item">
              <div>
                <img src="../../static/img/market/zrzc.svg">
                <span @click="details(117)">转让资产</span>
                <p>企业处置资产收益为正且对净利润有严重影响的类型</p>
              </div>
            </div>
            <div class="buttons-item">
              <div>
                <img src="../../static/img/market/fjcxsy.svg">
                <span @click="details(118)">非经常性损益</span>
                <p>分析非经常性损益的结构组合内容</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="buttons-box">
        <div class="buttons-box-header" @click="retract">
          <span>公司治理</span>
          <img src="../../static/img/retract.png" style="transform: rotate(180deg);">
        </div>
        <div class="buttons-box-retract">
          <div class="buttons-box-retract-box">
            <div class="buttons-item">
              <div>
                <img src="../../static/img/market/kggdjc.svg">
                <span @click="details(21)">控股股东减持</span>
                <p>企业实控人减持情况</p>
              </div>
            </div>
            <div class="buttons-item">
              <div>
                <img src="../../static/img/market/ggjc.svg">
                <span @click="details(22)">高管减持</span>
                <p>企业高管减持情况</p>
              </div>
            </div>
            <div class="buttons-item">
              <div>
                <img src="../../static/img/market/dwdb.svg">
                <span @click="details(23)">对外担保</span>
                <p>跟踪企业历年担保情况</p>
              </div>
            </div>
            <div class="buttons-item">
              <div>
                <img src="../../static/img/market/ryjg.svg">
                <span @click="details(24)">人员结构</span>
                <p>发现企业人员数量和结构变化</p>
              </div>
            </div>
            <div class="buttons-item">
              <div>
                <img src="../../static/img/market/skrbhl.svg">
                <span @click="details(25)">实控人变化率</span>
                <p>展示企业实控人变更</p>
              </div>
            </div>
            <div class="buttons-item">
              <div>
                <img src="../../static/img/market/gqzy.svg">
                <span @click="details(26)">股权质押</span>
                <p>揭示企业当前股权质押与冻结情况</p>
              </div>
            </div>
            <div class="buttons-item">
              <div>
                <img src="../../static/img/market/gglzl.svg">
                <span @click="details(27)">高管离职率</span>
                <p>展示企业近几年高管变动情况</p>
              </div>
            </div>
            <div class="buttons-item">
              <div>
                <img src="../../static/img/market/rzfh.svg">
                <span @click="details(28)">融资/分红</span>
                <p>企业上市以来融资和分红比对</p>
              </div>
            </div>
            <div class="buttons-item">
              <div>
                <img src="../../static/img/market/sjyj.svg">
                <span @click="details(29)">审计意见</span>
                <p>展示企业审计意见信息</p>
              </div>
            </div>
            <div class="buttons-item">
              <div>
                <img src="../../static/img/market/ryxl.svg">
                <span @click="details(210)">人员效率</span>
                <p>上市企业人均情况排名</p>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="buttons-box">
        <div class="buttons-box-header" @click="retract">
          <span>业绩披露</span>
          <img src="../../static/img/retract.png" style="transform: rotate(180deg);">
        </div>
        <div class="buttons-box-retract">
          <div class="buttons-box-retract-box">
            <div class="buttons-item">
              <div>
                <img src="../../static/img/market/yjyg.svg">
                <span @click="details(31)">业绩预告</span>
                <p>预先披露下一季度的业绩，盈利幅度</p>
              </div>
            </div>
            <div class="buttons-item">
              <div>
                <img src="../../static/img/market/yjkb.svg">
                <span @click="details(32)">业绩快报</span>
                <p>简略披露当期报告的主要指标</p>
              </div>
            </div>
            <div class="buttons-item">
              <div>
                <img src="../../static/img/market/dpl.svg">
                <span @click="details(33)">待披露</span>
                <p>预告披露下一季度定期报告的时间</p>
              </div>
            </div>
            <div class="buttons-item">
              <div>
                <img src="../../static/img/market/ypl.svg">
                <span @click="details(34)">已披露</span>
                <p>展示已披露报告中的部分指标</p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="content" id="content-iframe" v-if="sonPageShow" style="background-color: #f1f1f1;">
      <router-view />
    </div>

  </div>
</template>
  
<script>
import { linkName } from '../../static/js/util';

export default {
  data() {
    return {
      // isLogin: false,
      sonPageShow: false
    };
  },
  watch: {
    //恢复页面
    $route(to, from) {
      if(to.name=='market'){
        this.sonPageShow = false;
      }
    }
  },
  mounted() {
    // var logState = sessionStorage.getItem('isLogin');
    // if (logState != null && logState=='true') {
    //   this.isLogin = true;
    // }
  },
  methods: {
    retract(event) {
      // console.log(event)
      // console.log(event.parentElement.children)
      var element;
      if(event.srcElement.className=='buttons-box-header'){
        element = event.srcElement;
      }else {
        element = event.srcElement.parentElement;
      }

      if (element.parentElement.children[1].style.gridTemplateRows === "0fr") {
        element.parentElement.children[1].style.gridTemplateRows = "1fr";
        element.children[1].style.transform = "rotate(180deg)";
      } else {
        element.parentElement.children[1].style.gridTemplateRows = "0fr";
        element.children[1].style.transform = "rotate(0deg)";
      }
    },
    details(sign) {
      if (sessionStorage.getItem('isLogin')=='false') {
        this.$confirm('请先登录, 是否跳转登录界面?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          this.$router.push({name: 'login'});
        }).catch(()=>{});
        return;
      }
      this.sonPageShow = true;
      var pageName;
      switch (sign) {
        // 财务概览-----------------------------
        case 11:
          pageName = 'Increase';
          break;
        case 12:
          pageName = 'Expansion';
          break;
        case 13:
          pageName = 'ShrinkingCoreInterests';
          break;
        case 14:
          pageName = 'Goodwill';
          break;
        case 15:
          pageName = 'RevenueAndProfit';
          break;
        case 16:
          pageName = 'Decline';
          break;
        case 17:
          pageName = 'Investment';
          break;
        case 18:
          pageName = 'InvestmentFailure';
          break;
        case 19:
          pageName = 'CreditImpairment';
          break;
        case 110:
          pageName = 'ProfitAndCash';
          break;
        case 111:
          pageName = 'RevenueStructure';
          break;
        case 112:
          pageName = 'Merger';
          break;
        case 113:
          pageName = 'TransferSubsidiaries';
          break;
        case 114:
          pageName = 'AssetImpairment';
          break;
        case 115:
          pageName = 'ProfitStructure';
          break;
        case 116:
          pageName = 'HighLeverage';
          break;
        case 117:
          pageName = 'TransferAssets';
          break;
        case 118:
          pageName = 'ExtraordinaryItem';
          break;

        // 公司治理-----------------------------
        case 21:
          pageName = 'ShareholderReduction';
          break;
        case 22:
          pageName = 'ExecutiveReduction';
          break;
        case 23:
          pageName = 'ExternalGuarantee';
          break;
        case 24:
          pageName = 'PersonnelStructure';
          break;
        case 25:
          pageName = 'ActualControllerChange';
          break;
        case 26:
          pageName = 'EquityPledge';
          break;
        case 27:
          pageName = 'ExecutiveTurnover';
          break;
        case 28:
          pageName = 'FinancingDividends';
          break;
        case 29:
          pageName = 'AuditOpinion';
          break;
        case 210:
          pageName = 'PersonnelEfficiency';
          break;

        // 业绩披露-----------------------------
        case 31:
          pageName = 'PerformanceForecast';
          break;
        case 32:
          pageName = 'PerformanceExpress';
          break;
        case 33:
          pageName = 'ToDisclose';
          break;
        case 34:
          pageName = 'Disclosed';
          break;

        default:
          window.location.href = '/beawanHome/market';
      }
      linkName(this, pageName);
    },
    back() {
      //关掉iframe里的dialog
      // if (window.frames[0].frames.length == 1 && window.frames[0].document.getElementById('analysis').src != 'about:blank') {
      //   window.frames[0].vueTemp.analysisVisible = false;
      //   return;
      // }

      this.sonPageShow = false;
    }
  }
};
</script>
  
<style scoped>
.content {
  flex-direction: column;
}

.buttons-box {
  width: calc(100% - 40px);
  padding: 20px;
  margin-bottom: 15px;
  background-color: #fff;
  border-radius: 6px;
}

.buttons-box-header {
  display: flex;
  justify-content: center;
  align-items: center;
}

.buttons-box-header>span {
  font-size: 18px;
  cursor: pointer;
}

.buttons-box-header>img {
  width: 16px;
  height: 16px;
  margin-left: 15px;
  cursor: pointer;
}

.buttons-box-retract {
  display: grid;
  overflow: hidden;
  transition: 0.5s;
  grid-template-rows: 1fr;
}

.buttons-box-retract-box {
  min-height: 0px;
  display: flex;
  flex-wrap: wrap;
}

.buttons-item {
  height: 85px;
  padding-left: 45px;
  padding-top: 15px;
  width: calc(20% - 50px);
}

.buttons-item>div {
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  align-content: flex-start;
}

.buttons-item img {
  width: 17px;
  margin-right: 10px;
  /*cursor: pointer;*/
  background-color: #F8E8E9;
  padding: 6px;
  border-radius: 5px;
}

.buttons-item span {
  cursor: pointer;
}

.buttons-item p {
  font-size: 11px;
  color: #555;
  margin: 4px 0 0 0;
  /*cursor: pointer;*/
}
</style>